import { gsap } from 'gsap';
import { Helper } from "../../../core/utils/Helper";

export interface SpriteAnimateConfig{
    duration:number,
    toTexture?:PIXI.Texture
    ease?:any,
    scaling?:{
        from:PIXI.Point,
        to:PIXI.Point,
    }
}

export class SimpleSpriteSwap extends PIXI.Container {

    private tl:gsap.core.Timeline;

    private mainSprite:PIXI.Sprite;
    private subSprite:PIXI.Sprite;

    public get targetSwapTexture():PIXI.Texture{
        return this.mainSprite.texture != this.subSprite.texture &&
        (this.tl && this.tl.isActive()) ? this.subTexture : this.mainTexture;
    }

    public get mainTexture():PIXI.Texture{
        return this.mainSprite.texture;
    }

    public get subTexture():PIXI.Texture{
        return this.subSprite.texture;
    }

    public set mainTexture(val: PIXI.Texture){
        this.mainSprite.texture = val;
    }

    constructor(_texture?:PIXI.Texture){
        super();

        this.subSprite = this.addChild(new PIXI.Sprite(_texture));
        this.subSprite.anchor.set(0.5);
        this.subSprite.alpha = 0;

        this.mainSprite = this.addChild(new PIXI.Sprite(_texture));
        this.mainSprite.anchor.set(0.5);
    }

    public Animate(conf:SpriteAnimateConfig):gsap.core.Timeline{
        this.subSprite.texture = conf.toTexture ?? (conf.toTexture = this.mainSprite.texture);
        this.tl = Helper.setTimeline(this.tl, { onComplete:() => { 
            if(this.mainSprite && this.parent){
                this.mainSprite.texture = this.subSprite.texture;
                this.mainSprite.scale.set(1);
    
                this.mainSprite.alpha = 1;
                this.subSprite.alpha = 0;
            }
        }});

        this.tl.fromTo(this.mainSprite, { alpha: 1 }, { alpha: 0, duration: conf.duration, ease: conf.ease }, 0)
        this.tl.fromTo(this.subSprite, { alpha: 0 }, { alpha: 1, duration: conf.duration, ease: conf.ease }, 0)

        if(conf.scaling){
            this.tl.fromTo(this.subSprite.scale,
                { x: conf.scaling.from.x, y: conf.scaling.from.y },
                { x: 1, y: 1, duration: conf.duration, ease: conf.ease }, 0)
            this.tl.fromTo(this.mainSprite.scale,
                { x: 1, y: 1 },
                { x: conf.scaling.to.x, y: conf.scaling.to.y, duration: conf.duration, ease: conf.ease }, 0)
        }

        return this.tl;
    }

    public setTexture(_texture:PIXI.Texture):void{
        this.subSprite.texture = this.mainSprite.texture;
        this.mainSprite.texture = _texture;
    }
}